import React from "react";
import SignolUtils from "@src/utils/signolUtils";
import * as signolIcons from "@src/assets/icons";
import OperatorHooks from "@src/context/hooks/operatorHooks";
import { NotificationBadge } from "../atoms";
import { AppUtils } from "../../utils";

const MenuItem = ({ title, onSelect, path, isActive, icon }) => {
  const iconElement = typeof icon === "string" ? signolIcons[icon]() : icon;
  return (
    <div
      onClick={() => onSelect()}
      {...SignolUtils.makeTrackableDataAttributes({
        type: "MENU_ITEM",
        toURL: path,
      })}
      className={`group flex items-center px-4 py-3 font-bold cursor-pointer text-gray-800 border-l-4
              ${
                isActive
                  ? "border-primary-500 text-primary-500 bg-gray-100"
                  : "border-transparent hover:text-primary-500"
              }
              transition duration-100 ease-in-out`}
    >
      {iconElement}
      <span className="ml-4">{title}</span>
    </div>
  );
};

const NavMenu = (props) => {
  const {
    user,
    avatarInitials,
    // currentRole,
    onSwitchRole,
    onImpersonatedSession,
    currentPage,
    items,
    onItemSelect,
    onLogout,
  } = props;

  return (
    <>
      <div className="bg-white border-gray-100 border-r-2 h-full">
        <div className="sticky top-16 pt-4 pb-8">
          <>
            {items
              ?.filter((item) => !!item.pageTitle && !item.hidden)
              .map((item, idx) => {
                const isActive =
                  item.path === location.pathname ||
                  item.path.endsWith(currentPage);
                return (
                  <MenuItem
                    key={idx}
                    title={item.pageTitle}
                    icon={
                      item.path.includes("notifications") ? (
                        <NotificationBadge isActive={isActive} />
                      ) : isActive && !!item.menuIconActive ? (
                        item.menuIconActive
                      ) : (
                        item.menuIcon
                      )
                    }
                    path={item.path}
                    onSelect={() => onItemSelect(item.path)}
                    isActive={isActive}
                  />
                );
              })
              .slice()}
          </>
          <div className="md:hidden py-8 border-t border-gray-200">
            <div className="flex items-center px-6">
              <div className="flex-shrink-0">
                <span className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-500">
                  <span className="text-lg font-bold leading-none text-white">
                    {avatarInitials}
                  </span>
                </span>
              </div>
              <div className="ml-3">
                <div className="flex space-x-2 text-sm leading-6 text-gray-800">
                  {/* <span className="capitalize">{currentRole}</span> */}
                  <span className="capitalize">
                    {user.firstname && user.lastname
                      ? `${user.firstname} ${user.lastname}`
                      : ""}
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <MenuItem
                title="Profile"
                icon="about"
                onSelect={() => onItemSelect("profile")}
                isActive={currentPage === "profile"}
              />
              {!!onSwitchRole && (
                <div
                  className={`group flex items-center px-4 py-3 font-bold cursor-pointer text-gray-800 border-l-4 
                    border-transparent hover:text-gray-900 hover:bg-gray-50 hover:border-gray-300 
                    transition duration-150 ease-in-out`}
                  role="menuitem"
                  onClick={() => onSwitchRole(null)}
                >
                  <div className="w-6">{signolIcons.logout()}</div>
                  <span className="ml-4">Switch Role</span>
                </div>
              )}
              {!!onImpersonatedSession && (
                <div
                  className={`group flex items-center px-4 py-3 font-bold cursor-pointer text-gray-800 border-l-4 
                    border-transparent hover:text-gray-900 hover:bg-gray-50 hover:border-gray-300 
                    transition duration-150 ease-in-out`}
                  role="menuitem"
                  onClick={() => onImpersonatedSession()}
                >
                  <div className="w-6">{signolIcons.logout()}</div>
                  <span className="ml-4">Logout from User</span>
                </div>
              )}
              <div
                onClick={() => onLogout()}
                className={`group flex items-center px-4 py-3 font-bold cursor-pointer text-gray-800 border-l-4 
                  border-transparent hover:text-gray-900 hover:bg-gray-50 hover:border-gray-300 
                  transition duration-150 ease-in-out`}
              >
                <div className="w-6">{signolIcons.logout()}</div>
                <span className="ml-4">Logout</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// @observer
// class DashboardMenu extends Component {
//   constructor(props) {
//     super(props);

//     this.navMenu = React.createRef();
//     this.handleClickOutside = this.handleClickOutside.bind(this);
//   }

//   componentDidMount() {
//     document.addEventListener('mousedown', this.handleClickOutside);
//   }

//   componentWillUnmount() {
//     document.removeEventListener('mousedown', this.handleClickOutside);
//   }

//   // close navigation if user clicks outside of menu
//   handleClickOutside(event) {
//     if (this.props.rootStore.displayNavigationMenu && this.navMenu && !this.navMenu.current.contains(event.target)) {
//       this.props.rootStore.toggleNavigationMenu();
//     }
//   }

//   render() {
//     const {
//       user,
//       avatarInitials,
//       currentRole,
//       currentPage,
//       items,
//       onItemSelect,
//       onLogout,
//       hasNewNotifications
//     } = this.props;

//     return (
//       <>
//         <div
//           className="bg-gradient-to-r from-neutral-200 to-white border-gray-100 border-r-2 h-full"
//           ref={this.navMenu}
//         >
//           <div className="sticky top-16 pt-4 pb-8">
//             <>
//               {items
//                 .map((item, idx) => {
//                   let badge;
//                   // only "notification" menu item displays a badge
//                   if (item.menuIcon === 'notification') {
//                     badge = hasNewNotifications;
//                   }
//                   const isActive = currentPage === (this.props.rootStore.getLastAppPath(item.path) || 'overview');
//                   return (
//                     <MenuItem
//                       key={idx}
//                       title={item.pageTitle}
//                       icon={item.menuIcon}
//                       onSelect={() => onItemSelect(item.path)}
//                       isActive={isActive}
//                       badge={badge}
//                     />
//                   );
//                 })
//                 .slice()
//                 .reverse()}
//             </>
//             <div className="md:hidden py-8 border-t border-gray-200">
//               <div className="flex items-center px-6">
//                 <div className="flex-shrink-0">
//                   <span className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-500">
//                     <span className="text-lg font-bold leading-none text-white">{avatarInitials}</span>
//                   </span>
//                 </div>
//                 <div className="ml-3">
//                   <div className="flex space-x-2 text-sm leading-6 text-gray-800">
//                     <span className="capitalize">{currentRole}</span>
//                     <span className="capitalize">{user.lastname || ''}</span>
//                   </div>
//                 </div>
//               </div>
//               <div className="mt-4">
//                 <MenuItem
//                   title="Profile"
//                   icon="about"
//                   onSelect={() => onItemSelect('/dashboard/profile')}
//                   isActive={currentPage === 'profile'}
//                 />
//                 <div
//                   onClick={() => onLogout()}
//                   className={`group flex items-center px-4 py-3 font-bold cursor-pointer text-gray-800 border-l-4
//                   border-transparent hover:text-gray-900 hover:bg-gray-50 hover:border-gray-300
//                   transition duration-150 ease-in-out`}
//                 >
//                   <div className="w-6">{signolIcons.logout()}</div>
//                   <span className="ml-4">Logout</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }
// }

export default NavMenu;

export const NavMenuControls = {
  logoSrc: {
    controlType: "Text",
    description: "SRC of customer logo",
  },
  signolLogoSrc: {
    controlType: "Text",
    description: "SRC of signol logo",
  },
  avatarInitials: {
    controlType: "Text",
    description: "User initials to display in Avatar",
  },
  showMenu: {
    controlType: "boolean",
    description: "Is the burger menu to be displayed",
  },
  containerWidth: {
    controlType: "Text",
    description: "Overide for the width of the content defaults to 1120px",
  },
  navigationMenuOpen: {
    controlType: "boolean",
    description: "Is the navigation menu open",
  },
};
NavMenu.propTypes = AppUtils.getPropTypeFromControls(NavMenuControls);
